"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressApiError = exports.AddressExceptions = void 0;
const errors_1 = require("@deliverr/errors");
var AddressExceptions;
(function (AddressExceptions) {
    AddressExceptions["INVALID_INPUT"] = "INVALID_INPUT";
    AddressExceptions["UNAUTHORIZED"] = "UNAUTHORIZED";
    AddressExceptions["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    AddressExceptions["OPENSEARCH_FAILURE"] = "OPENSEARCH_FAILURE";
    AddressExceptions["NOT_FOUND"] = "NOT_FOUND";
})(AddressExceptions = exports.AddressExceptions || (exports.AddressExceptions = {}));
/**
 * An implementation of the AbstractDeliverrError that strongly types the
 * code to the AbstractDeliverrExceptions enum, and that serializes both code and
 * message to JSON.
 */
class AddressApiError extends errors_1.AbstractDeliverrError {
    toJSON() {
        return {
            code: this.code,
            message: this.message,
        };
    }
}
exports.AddressApiError = AddressApiError;
//# sourceMappingURL=AddressExceptions.js.map